"use client";
import {
  mockNoticeBand
} from "./chunk-3I7JYWXF.mjs";
import {
  Link_default
} from "./chunk-ZRVIWEMV.mjs";
import {
  Icon_default
} from "./chunk-KJNGPZGH.mjs";

// src/components/sections/NoticeBand/NoticeBand.tsx
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var NoticeBand = forwardRef(
  function NoticeBand2({
    title,
    description,
    firstAnchor = mockNoticeBand.firstAnchor,
    secondAnchor = mockNoticeBand.secondAnchor
  }, ref) {
    return /* @__PURE__ */ jsxs("div", { ref, className: "py-40 px-24 w-full bg-display-200", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col pb-48 mx-auto w-full max-w-[1280px] xs:text-center border-b border-display-400", children: [
        /* @__PURE__ */ jsx(
          "h2",
          {
            className: "mb-24 text-xl leading-5 font-bold md:text-2xl md:leading-6 font-sans",
            dangerouslySetInnerHTML: {
              __html: title
            }
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-col xs:flex-row justify-center", children: [
          /* @__PURE__ */ jsxs(
            Link_default,
            {
              href: firstAnchor.href,
              className: "flex items-center font-sans mb-16 xs:mb-0 font-semibold text-stone-500 text-lg leading-5",
              children: [
                /* @__PURE__ */ jsx(
                  Icon_default,
                  {
                    name: firstAnchor.icon,
                    className: "w-24 h-24 mr-10"
                  }
                ),
                firstAnchor.label
              ]
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "hidden xs:block mx-16 border border-display-400" }),
          /* @__PURE__ */ jsxs(
            Link_default,
            {
              href: secondAnchor.href,
              className: "flex items-center font-sans font-semibold text-stone-500 text-lg leading-5",
              children: [
                /* @__PURE__ */ jsx(
                  Icon_default,
                  {
                    name: secondAnchor.icon,
                    className: "w-24 h-24 mr-10"
                  }
                ),
                secondAnchor.label
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsx(
        "p",
        {
          className: "mx-auto mt-48 w-full max-w-[1280px] text-sm leading-3 font-sans",
          dangerouslySetInnerHTML: {
            __html: description
          }
        }
      )
    ] });
  }
);
var NoticeBand_default = NoticeBand;

export {
  NoticeBand_default
};
